(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sanae-shipping-notice"] && !Shopify.designMode) return;
  try {
    
(()=>{const r=document.querySelector('[data-sanae-shipping-notice]');if(!r)return;const p=r.querySelector('[data-primary]'),s=r.querySelector('[data-secondary]'),e=r.dataset.calendarEndpoint,h=new Set(['2026-1-1','2026-1-2','2026-1-3','2026-1-12','2026-2-11','2026-2-23','2026-3-20','2026-4-29','2026-5-3','2026-5-4','2026-5-5','2026-5-6','2026-7-20','2026-8-11','2026-9-21','2026-9-22','2026-9-23','2026-10-12','2026-11-3','2026-11-23','2027-1-1','2027-1-11','2027-2-11','2027-2-23','2027-3-21','2027-4-29','2027-5-3','2027-5-4','2027-5-5','2027-7-19','2027-8-11','2027-9-20','2027-9-23','2027-10-11','2027-11-3','2027-11-23']);const msg=(a,b='')=>{p.textContent=a;s.textContent=b;s.hidden=!b};const now=()=>{const v={};new Intl.DateTimeFormat('en-CA',{timeZone:'Asia/Tokyo',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',hourCycle:'h23'}).formatToParts(new Date()).forEach(x=>{if(x.type!=='literal')v[x.type]=+x.value});return{year:v.year,month:v.month,day:v.day,hour:v.hour}};const add=(d,n)=>{const x=new Date(Date.UTC(d.year,d.month-1,d.day+n));return{year:x.getUTCFullYear(),month:x.getUTCMonth()+1,day:x.getUTCDate(),hour:d.hour}};const dow=d=>new Date(Date.UTC(d.year,d.month-1,d.day)).getUTCDay();const key=d=>d.year+'-'+d.month+'-'+d.day;const nth=(y,m,n,w)=>{let c=0;for(let d=1;d<=new Date(Date.UTC(y,m,0)).getUTCDate();d++)if(new Date(Date.UTC(y,m-1,d)).getUTCDay()===w&&++c===n)return d;return-1};const run=async()=>{const d=now(),months=[d,add({...d,day:1},35)],data=new Map(await Promise.all([...new Map(months.map(x=>[x.year+'-'+x.month,x])).values()].map(async x=>{const q=await fetch(e+'?year='+x.year+'&month='+x.month,{cache:'no-store'});if(!q.ok)throw Error();const j=await q.json();return[j.year+'-'+j.month,j]})));const closed=x=>{const m=data.get(x.year+'-'+x.month)||{},a=m.extra_closed||[],o=m.except_open||[];return !o.includes(x.day)&&(a.includes(x.day)||x.day===nth(x.year,x.month,2,3)||x.day===nth(x.year,x.month,4,4))};const holiday=x=>dow(x)===0||h.has(key(x));const next=()=>{for(let i=1;i<15;i++){const x=add(d,i);if(!holiday(x)&&!closed(x))return x}return null};const label=x=>x.month+'月'+x.day+'日',tom=add(d,1),n=next(),mode=r.dataset.previewMode;if(mode==='afternoon')return msg('通常営業','午後からのオーダーの場合には、次の営業日の発送になることがあります。');if(mode==='before_closure')return msg('通常営業','明日は定休日のため、定休日が明けた通常営業日の発送になることがあります');if(mode==='sunday_holiday')return msg('日曜・祝日のため、焙煎・発送は明日になります');if(mode==='next_business_day')return msg('日曜・祝日のため、焙煎・発送は次の通常営業日になります');if(closed(d))return msg('本日は定休日のため、焙煎・発送は'+(n?label(n):'次の通常営業日')+'になります');if(holiday(d))return msg(!holiday(tom)&&!closed(tom)?'日曜・祝日のため、焙煎・発送は明日になります':'日曜・祝日のため、焙煎・発送は'+(n?label(n):'次の通常営業日')+'の通常営業日になります');if(closed(tom))return msg('通常営業','明日は定休日のため、定休日が明けた通常営業日の発送になることがあります');return d.hour>=12?msg('通常営業','午後からのオーダーの場合には、次の営業日の発送になることがあります。'):msg('通常営業')};run().catch(()=>msg('営業情報を取得できませんでした。'))})();

  } catch(e) { console.error(e); }
})();
})();
